import React, { Component } from 'react'
import { observer } from 'mobx-react'
import settings from '../settings'

const { BUILD_DOMAIN, ICAS_API_URL } = settings
export const baseUrl = BUILD_DOMAIN
export const icasBaseUrl = ICAS_API_URL

const redirectUserToPreviewPage = (lastSavedFormAddress) => () => {
  redirectToForeignUrl(`${baseUrl}/${lastSavedFormAddress}`)
}

export const getFormUrlBySlug = (formSlug) => `${baseUrl}/${formSlug}`

const redirectToForeignUrl = (url, newTab = true) => {
  newTab ? window.open(url) : changeWindowLocation(url)
}

const redirectToHomePage = () => {
  redirectToForeignUrl(baseUrl, false)
}

const redirectToLogout = () => {
  redirectToForeignUrl(`${icasBaseUrl}/profiles/logout/`, false)
}

const changeWindowLocation = (url) => {
  window.location.href = url
}

const withParam = (paramName) => (RenderAble) => {
  class WithParam extends Component {
    render() {
      const { match = {} } = this.props

      let requestedParam = {}

      if (typeof paramName === 'string') {
        requestedParam = {
          [paramName]: match.params ? match.params[paramName] : undefined,
        }
      } else if (Array.isArray(paramName)) {
        requestedParam = paramName
          .map((param) => ({
            [param]: match.params ? match.params[param] : undefined,
          }))
          .reduce((acc, current) => ({ ...acc, ...current }), {})
      } else {
        throw new TypeError(
          `type of requested param must be either
         a string or an array, received ${typeof paramName}`
        )
      }

      return <RenderAble {...requestedParam} {...this.props} />
    }
  }

  return WithParam
}
export {
  redirectUserToPreviewPage,
  withParam,
  redirectToForeignUrl,
  redirectToHomePage,
  redirectToLogout,
}
export default observer(withParam)
